import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from "react";
const SvgFrance = (props)=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 512 512",
        style: {
            enableBackground: "new 0 0 512 512"
        },
        xmlSpace: "preserve",
        width: "1em",
        height: "1em",
        ...props,
        children: [
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#41479b"
                },
                d: "M112 0C50.144 0 0 50.144 0 112v288c0 61.856 50.144 112 112 112h58.667V0H112z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#f5f5f5"
                },
                d: "M170.667 0v512h170.666V0z"
            }),
            /*#__PURE__*/ _jsx("path", {
                style: {
                    fill: "#ff4b55"
                },
                d: "M400 0h-58.667v512H400c61.856 0 112-50.144 112-112V112C512 50.144 461.856 0 400 0z"
            })
        ]
    });
export { SvgFrance };
